module.exports = __webpack_public_path__ + "img/ic_marker_asset_blue_issue.b37539dc.png";